export const getVerticalOrientation = () => {
  return {
    vertical: true,
    horizontal: false,
  };
};

export const getHorizontalOrientation = () => {
  return {
    vertical: false,
    horizontal: true,
  };
};
